import logo from "./logo.png";

export default function Logo() {
  return (
    <img className="object-scale-down w-36" src={logo} alt="Highland Logo" />
  );
}
